import React from 'react';
import * as S from './legalStyles';

const TermsContentEn: React.FC = () => (
  <>
    <div style={{
      background: '#fffbeb', border: '2px solid #fcd34d', borderRadius: '12px',
      padding: '20px', marginBottom: '30px',
    }}>
      <h3 style={{ color: '#92400e', marginBottom: '10px' }}>⚠️ Important Notice — Direct-Trade Platform</h3>
      <ul style={{ color: '#a16207', margin: 0, paddingLeft: '20px', lineHeight: '1.8' }}>
        <li><strong>Freematch is an intermediary platform connecting experts and clients.</strong></li>
        <li>All transactions take place directly between the parties; the platform does not intervene in transactions.</li>
        <li>Payment, refunds, and disputes must be resolved directly between the parties.</li>
        <li>The platform charges 0% transaction fees.</li>
      </ul>
    </div>

    <section style={S.section}>
      <h2 style={S.h2}>Article 1 (Purpose)</h2>
      <p style={S.p}>
        These Terms govern the conditions and procedures for using the freelancer-matching service
        (the "Service") provided by Freematch (the "Company"), as well as the rights, obligations,
        and responsibilities between the Company and its members.
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>Article 2 (Definitions)</h2>
      <ul style={S.ul}>
        <li><strong>"Service"</strong>: the platform provided by the Company that connects freelancers and clients</li>
        <li><strong>"Member"</strong>: a person who has agreed to these Terms and uses the Service</li>
        <li><strong>"Client"</strong>: a member who posts a project and looks for an expert</li>
        <li><strong>"Expert"</strong>: a member who lists a service and carries out projects</li>
        <li><strong>"Direct Trade"</strong>: a payment arrangement made directly between the client and the expert, outside the platform</li>
      </ul>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>Article 3 (Provision of Service)</h2>
      <p style={S.p}>The Company provides the following services:</p>
      <ul style={S.ul}>
        <li>Posting and searching projects</li>
        <li>Posting and searching services (expert profiles)</li>
        <li>Real-time chat between clients and experts</li>
        <li>Trade status management (in progress / completed)</li>
        <li>Review and rating system</li>
        <li>AI agent tools (AI proposal draft, AI contract draft, AI expert analysis report)</li>
      </ul>
      <p style={{ ...S.p, marginTop: '10px' }}>
        <strong>※ The Company does not provide a payment intermediary service.</strong> All payments are made directly between the parties.
      </p>
    </section>

    <section style={{ ...S.section, background: '#f0fdf4', padding: '20px', borderRadius: '12px', border: '1px solid #86efac' }}>
      <h2 style={{ ...S.h2, color: '#166534' }}>Article 4 (Direct Trades and the Platform's Role)</h2>
      <p style={{ ...S.p, color: '#15803d' }}>
        ① <strong>The Company acts as a mail-order/e-commerce intermediary and is not a party to any transaction.</strong><br/>
        ② The Company only provides a platform service that connects clients and experts.<br/>
        ③ All transactions (contracts, payments, and work performance) take place directly between the parties.<br/>
        ④ The Company does not receive or intermediate transaction funds.<br/>
        ⑤ The Company only displays transaction status (in progress / completed) on the platform.
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>Article 5 (Platform Fees)</h2>
      <p style={S.p}>
        ① <strong>The Company does not charge transaction fees (0%).</strong><br/>
        ② The AI proposal draft, AI contract draft, and AI expert analysis report are provided on a pay-per-use basis (KRW 490 each, or a 12-pack for KRW 4,990) — not by subscription.<br/>
        ③ Credit purchases are made on the website (PC or web browser) and are usable immediately after payment. Credits are a tool-usage fee unrelated to deal outcomes; refunds are available for unused credits.
      </p>
    </section>

    <section style={{ ...S.section, background: '#fef2f2', padding: '20px', borderRadius: '12px', border: '1px solid #fca5a5' }}>
      <h2 style={{ ...S.h2, color: '#991b1b' }}>Article 6 (Disclaimer) ⚠️</h2>
      <p style={{ ...S.p, color: '#dc2626' }}>
        ① <strong>The Company is not liable for any disputes, damages, or losses arising from transactions between members.</strong><br/>
        ② All monetary matters, including payment, refunds, and cancellations, must be resolved directly between the parties.<br/>
        ③ The Company does not guarantee the accuracy or reliability of information posted by members.<br/>
        ④ Expert verification (e.g., four major insurances) is for reference only and is not guaranteed by the Company.<br/>
        ⑤ Members must independently verify the other party's identity and capability before transacting.
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>Article 7 (Recommendations for Safe Transactions)</h2>
      <p style={S.p}>The Company recommends the following for safe transactions:</p>
      <ul style={S.ul}>
        <li>Use a deposit/balance payment structure (e.g., 30% upfront, 70% upon completion)</li>
        <li>Use payment methods that leave a record, such as Kakao Pay or Toss</li>
        <li>Clearly agree on scope of work and schedule via chat</li>
        <li>Review interim deliverables and provide feedback</li>
        <li>Press "Trade Complete" after the work is finished to keep a record</li>
      </ul>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>Article 8 (Member Obligations)</h2>
      <p style={S.p}>Members must not engage in the following conduct:</p>
      <ul style={S.ul}>
        <li>Stealing another person's information</li>
        <li>Registering a false profile or portfolio</li>
        <li>Infringing the copyright or other intellectual property rights of the Company or third parties</li>
        <li>Fraud, deception, or other unfair trading conduct</li>
        <li>Posting obscene or violent content</li>
        <li>Any other illegal or improper conduct</li>
      </ul>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>Article 9 (Withdrawal and Loss of Membership)</h2>
      <p style={S.p}>
        ① A member may request withdrawal at any time, and the Company will process it immediately.<br/>
        ② If a member violates these Terms, the Company may restrict or suspend that member's status.<br/>
        ③ If there is an ongoing transaction, please consult with the counterparty before withdrawing.
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>Article 10 (Dispute Resolution)</h2>
      <p style={S.p}>
        ① Disputes arising from transactions between members must be resolved through consultation between the parties.<br/>
        ② The Company does not provide dispute mediation services.<br/>
        ③ Matters not specified in these Terms shall be governed by relevant laws and regulations.<br/>
        ④ Disputes arising from use of the Service shall be subject to the exclusive jurisdiction of the court having jurisdiction over the Company's location.
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>Business Information</h2>
      <p style={S.p}>
        <strong>Company Name:</strong> KUNKONG<br/>
        <strong>Representative:</strong> Park Ki-beom<br/>
        <strong>Business Registration No.:</strong> 306-38-75095<br/>
        <strong>Address:</strong> 3F, 3-4 Wangbaesan 1-gil, Hwaseong-si, Gyeonggi-do, Republic of Korea<br/>
        <strong>Phone:</strong> +82 10-6284-2450<br/>
        <strong>Email:</strong> kunkong.co@gmail.com
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>Supplementary Provision</h2>
      <p style={S.p}>These Terms take effect on January 29, 2026.</p>
    </section>
  </>
);

export default TermsContentEn;
